import React from 'react'

function Acountant({accountantInformation,setAccountantInformation}) {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAccountantInformation({
      ...accountantInformation,
      [name]: value
    });
  };
  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
    <div className="flex flex-col sm:flex-row gap-4">
      {/* Contact Person */}
      <div className="flex flex-col w-full sm:w-[45%]">
        <label htmlFor="accountantPerson" className="mb-2 font-medium">Accountant Name:</label>
        <input
          id="accountantPerson"
          name="accountantPerson"
          className="border-2 border-gray-400 p-2 rounded w-full"
          placeholder="Enter acountant name"
          value={accountantInformation.accountantPerson}
          onChange={handleInputChange}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[45%]">
        <label htmlFor="acountantEmail" className="mb-2 font-medium">Accountant Email:</label>
        <input
          id="acountantEmail"
          name="acountantEmail"
          className="border-2 border-gray-400 p-2 rounded w-full"
          placeholder="Enter acountant email"
          value={accountantInformation.accountantEmail}
          onChange={(e) =>
            setAccountantInformation((prevGstin) => ({
                ...prevGstin,
                accountantEmail: e.target.value
            }))
        }
        />
      </div>

      {/* Contact Number */}
      <div className="flex flex-col w-full sm:w-[45%] ml-auto">
        <label htmlFor="accountantNumber" className="mb-2 font-medium">Accountant Number:</label>
        <input
          id="accountantNumber"
          name="accountantNumber"
          className="border-2 border-gray-300 p-2 rounded w-full"
          placeholder="Enter acountant number"
          value={accountantInformation.accountantNumber}
          onChange={(e) => {
            const input = e.target.value;
            if (/^\d{0,10}$/.test(input)) {
              setAccountantInformation((prevInfo) => ({
                ...prevInfo,
                accountantNumber: input
              }));
            }
            }}
            onBlur={(e) => {
            // optional: mark as touched or validate on blur
            const input = e.target.value;
            if (input.length !== 10) {
                alert("Phone number must be exactly 10 digits");
                setAccountantInformation((prevInfo) => ({
                ...prevInfo,
                accountantNumber: "", // rxeset field
              }));
            }
          }}
        />
      </div>
    </div>
   </div>
  )
}

export default Acountant
